import { DefaultChatTransport } from 'ai'

const { VITE_ALGOLIA_APP_ID, VITE_ALGOLIA_SEARCH_KEY, VITE_ALGOLIA_AI_AGENT_ID } = import.meta.env

export function isAlgoliaAiConfigValid() {
  return Boolean(VITE_ALGOLIA_APP_ID && VITE_ALGOLIA_SEARCH_KEY && VITE_ALGOLIA_AI_AGENT_ID)
}

export function createAlgoliaChatTransport(agentId?: string) {
  const appId = VITE_ALGOLIA_APP_ID
  const selectedAgentId = agentId || VITE_ALGOLIA_AI_AGENT_ID
  const apiKey = VITE_ALGOLIA_SEARCH_KEY

  return new DefaultChatTransport({
    api: `https://${appId}.algolia.net/agent-studio/1/agents/${selectedAgentId}/completions?compatibilityMode=ai-sdk-5`,
    headers: {
      'x-algolia-application-id': appId,
      'x-algolia-api-key': apiKey,
    },
    body: {
      searchParameters: {
        attributesToRetrieve: ['title', 'type', 'body', 'url'],
        restrictSearchableAttributes: ['title', 'body'],
        distinct: true,
        hitsPerPage: 4,
      },
    },
    prepareSendMessagesRequest: ({
      id,
      messages,
      body,
      headers,
      credentials,
      requestMetadata,
      trigger,
      messageId,
    }) => ({
      body: {
        ...body,
        id,
        trigger,
        messageId,
        metadata: requestMetadata,
        messages: messages.map((message) => {
          if (message.role !== 'assistant' || !Array.isArray(message.parts)) {
            return message
          }
          return {
            ...message,
            parts: message.parts.filter((part) => !part.type.startsWith('data-') && !part.type.startsWith('tool-')),
          }
        }),
      },
      headers,
      credentials,
    }),
  })
}

export async function sendFeedback(messageId: string, feedback: 'up' | 'down', agentId?: string) {
  const appId = VITE_ALGOLIA_APP_ID
  const selectedAgentId = agentId || VITE_ALGOLIA_AI_AGENT_ID
  const apiKey = VITE_ALGOLIA_SEARCH_KEY

  const response = await fetch(`https://${appId}.algolia.net/agent-studio/1/feedback`, {
    method: 'POST',
    headers: {
      'X-Algolia-Application-Id': appId,
      'X-Algolia-API-Key': apiKey,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      messageId,
      agentId: selectedAgentId,
      vote: feedback === 'up' ? 1 : 0, // 1 = thumbs up, 0 = thumbs down
    }),
  })

  if (!response.ok) {
    console.error('Failed to send feedback:', await response.text())
  }
  return response.ok
}
